import React from 'react';
import ContentLoader from 'react-content-loader';

const SelectFieldLoader = () => (
  <ContentLoader
    speed={2}
    width={'100%'}
    height={48}
    backgroundColor="#E5E5E5"
    foregroundColor="#DBDBDB"
  >
    <rect x="0" y="0" rx="2" ry="2" width={'100%'} height={48} />
  </ContentLoader>
);

export default SelectFieldLoader;
